<template>
  <div class="form-abm">
    <b-card :header="titulo">
      <b-form>
        <b-form-group
          label="Fecha"
          label-for="fechaAutorizacion"
          :label-cols="labelCols"
          description="Fecha de autorización de la transferencia"
          horizontal>
          <b-form-input 
            id="fechaAutorizacion" 
            v-model="fechaAutorizacion" 
            type="date">
          </b-form-input>
        </b-form-group>

        <b-form-group
          v-if="transferenciaId == 0"
          label="Importe"
          label-for="importe"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="importe"
            v-model.trim="$v.importe.$model" 
            :state="importeValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="importeFeedback">
            {{ importeInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          v-if="transferenciaId != 0"
          label="Importe"
          label-for="transferenciaImporte"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="transferenciaImporte"
            :value="importe | moneda" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

        <b-form-group
          label="Observaciones"
          label-for="observaciones"
          :label-cols="labelCols"
          horizontal>
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="3"
            max-rows="3"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </b-form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button" 
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="close">Cerrar</b-button>
      </div>
    </b-card>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, decimal, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferencia/getField',
  mutationType: 'transferencia/updateField',
});

export default {
  name: 'TransferenciaABM',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    eventoId: {
      type: Number,
      default: 0
    },
    participanteId: {
      type: Number,
      default: 0
    },
    eventoEtapaId: {
      type: Number,
      default: 0
    },
    transferenciaId: {
      type: Number,
      default: 0
    },
    transferenciaImporte: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'fechaAutorizacion',
      'importe',
      // 'completada',
      'observaciones',
    ]),
    titulo() {
      if (this.transferenciaId != 0) {
        return 'Autorización de Retransferencia';
      }
      return 'Autorización de Transferencia';
    }
  },  
  created() {
    let params= {
      eventoId: this.eventoId,
      participanteId: this.participanteId,
      eventoEtapaId: this.eventoEtapaId,
      transferenciaId: this.transferenciaId,
      importe: this.transferenciaImporte
    }

    this.showSpinner();
    this.$store.dispatch('transferencia/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.required) {
            this.importeInvalidoMsj = 'Debe ingresar el importe de la transferencia';
          } else if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de la transferencia no es válido';
          } 
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          } 
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('transferencia/save')
            .then(()  => this.showModalMsj('La autorización se registró con éxito.', this.close.bind(this, true), this.close.bind(this, true), 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        } 
      }
    },
    close(saved) {
      let transferenciaSaved = false | saved;

      this.$emit('close', transferenciaSaved);
    },
  },
  watch: {
  },
  validations: {
    importe: {
      required,
      decimal
    },
    observaciones: {
      // required,
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>
